/* Olive & June — Dip landing page behaviour. Safe to load more than once. */
(function () {
  if (window.DipPage) return;

  var DipPage = (window.DipPage = {
    /* Cart hook. Set window.DipPage.onAdd = function (item, form) { ...; return true; }
       to open the theme's cart drawer yourself. If it is not set (or does not return true),
       the visitor is sent to the cart URL, which the theme already turns into the AJAX drawer. */
    onAdd: null
  });

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- Side-scroll rows ---------- */
  var CHEVRON = {
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>'
  };

  function makeBtn(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dp-scroller__btn dp-scroller__btn--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Scroll to previous' : 'Scroll to next');
    b.innerHTML = CHEVRON[dir];
    return b;
  }

  function initScroller(wrap) {
    if (wrap.getAttribute('data-dp-ready')) return;
    var track = wrap.querySelector('[data-dp-track]');
    if (!track) return;
    wrap.setAttribute('data-dp-ready', '1');

    var prev = makeBtn('prev');
    var next = makeBtn('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    var itemSel = wrap.getAttribute('data-dp-item');

    function stepSize() {
      var first = itemSel ? track.querySelector(itemSel) : track.children[0];
      if (!first) return track.clientWidth * 0.8;
      var gap = itemSel ? 0 : parseFloat(getComputedStyle(track).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
      wrap.classList.toggle('is-static', max <= 0);
    }

    function go(dir) {
      track.scrollBy({ left: dir * stepSize(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Autoplay video: honour reduced motion ---------- */
  function initVideos(scope) {
    var vids = scope.querySelectorAll('[data-dp-video] video[autoplay]');
    Array.prototype.forEach.call(vids, function (v) {
      if (!reduceMotion || v.getAttribute('data-dp-motion')) return;
      v.setAttribute('data-dp-motion', '1');
      v.pause();
      var t = v.closest('[data-dp-video]').querySelector('[data-dp-toggle="video"]');
      if (t) setToggle(t, true);
    });
  }

  function setToggle(btn, paused) {
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
  }

  function init(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dp-scroller]'), initScroller);
    initVideos(scope);
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-dp-toggle], [data-dp-play]') : null;
    if (!t) return;

    if (t.hasAttribute('data-dp-toggle')) {
      if (t.getAttribute('data-dp-toggle') === 'marquee') {
        var m = t.closest('.dp-marquee');
        var paused = !m.classList.contains('is-paused');
        m.classList.toggle('is-paused', paused);
        setToggle(t, paused);
      } else {
        var v = t.closest('[data-dp-video]').querySelector('video');
        if (!v) return;
        if (v.paused) { v.play(); setToggle(t, false); } else { v.pause(); setToggle(t, true); }
      }
      return;
    }

    /* Click-to-load player (Dip 101) */
    var box = t.closest('[data-dp-player]');
    var tpl = box && box.querySelector('template');
    if (!tpl) return;
    box.innerHTML = '';
    box.appendChild(tpl.content.cloneNode(true));
    var media = box.querySelector('iframe, video');
    if (media) {
      if (media.tagName === 'VIDEO') { var p = media.play(); if (p && p.catch) p.catch(function () {}); }
      media.focus();
    }
  });

  /* ---------- Add to cart (shade cards) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-dp-add')) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn.querySelector('.dp-btn__label') || btn;
    var msg = form.parentNode.querySelector('.dp-card__msg');
    var original = label.textContent;
    if (btn.disabled) return;
    btn.disabled = true;
    label.textContent = 'Adding…';
    if (msg) msg.textContent = '';

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        label.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('dip:cart-add', { detail: { item: res.data } }));
        var handled = typeof DipPage.onAdd === 'function' && DipPage.onAdd(res.data, form) === true;
        if (!handled) {
          var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
          window.location.assign(cartUrl);
          return;
        }
        setTimeout(function () { label.textContent = original; btn.disabled = false; }, 1800);
      })
      .catch(function (err) {
        label.textContent = original;
        btn.disabled = false;
        if (msg) msg.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.';
      });
  });

  /* ---------- Boot + theme editor ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
